<template>
  <div class="container mb-4">
    <DataTable :value="processOrderList(FINISHED_ORDERS_BY_TYPE('feralcoIntern'))" :autoLayout="true" data-key="order.id" :selection.sync="selectedFinishedOrders" :filters="filters">
      <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
      <Column field="date" header="Lossningsdatum" :sortable="true" />
      <Column field="order.data.fraktsedelNr" header="Fraktsedel Nr" :sortable="true" />
      <Column field="order.data.inkopsNr" header="Inköps Nr" :sortable="true" />
      <Column field="order.data.loadingPlaces" header="Lastplats" :sortable="true" />
      <Column field="order.data.deliveryPlaces" header="Lossningsplats" :sortable="true" />
      <Column field="order.data.productId" header="Produkt" :sortable="true" />
      <Column field="order.data.retur" header="Retur" :sortable="true" >
        <template #body="slotProps">
          <i :class="slotProps.data.order.data.retur ? 'pi pi-check' : 'pi pi-times'"></i>
        </template>
      </Column>
      <Column header="Lastat" bodyStyle="text-align: right">
        <template #body="slotProps">
          {{fimCalculateLoadedAmount(slotProps.data.order.data) | round2dec}}
        </template>
      </Column>
      <Column headerStyle="width: 8em" bodyStyle="text-align: center">
        <template #header>
          <Button type="button" :icon="editAllowed ? 'pi pi-unlock' : 'pi pi-lock'" @click="editAllowed = !editAllowed"></Button>
        </template>
        <template #body="slotProps">
          <Button icon="pi pi-undo" :disabled="!editAllowed" @click="resetOrder(slotProps.data.order.id)" />
          <Button icon="pi pi-ban" :disabled="!editAllowed" @click="archiveOrder(slotProps.data.order.id)" />
        </template>
      </Column>
      <template #header>
        <div style="text-align: left">
          <Button label="Skapa faktura" icon="pi pi-plus" :disabled="selectedFinishedOrders.length == 0" @click="newInvoice = true" />
          <i class="pi pi-search" style="margin: 4px 4px 0px 0px;"></i>
          <InputText v-model="filters['global']" placeholder="Sökfilter" size="50" />
        </div>
      </template>
      <template #footer>
        <div style="text-align: left">
          <Button label="Skapa faktura" icon="pi pi-plus" :disabled="selectedFinishedOrders.length === 0" @click="newInvoice = true" />
        </div>
      </template>
      <template #empty>
        Inga ordrar redo för fakturering ännu
      </template>
    </DataTable>

    <Dialog header="Ange namn för ny faktura" :visible.sync="newInvoice">
      <InputText v-model="newInvoiceName" placeholder="Fakturanamn" size="50" />
      <template #footer>
        <Button label="Skapa faktura" icon="pi pi-check" :disabled="newInvoiceName.length === 0" @click="addToNewInvoice(newInvoiceName, selectedFinishedOrders)"/>
        <Button label="Avbryt" icon="pi pi-times" class="p-button-secondary" @click="newInvoice = false" />
      </template>
    </Dialog>

    <template v-for="activeInvoice in INVOICES_NEW_BY_TYPE('feralcoIntern').sort((e1, e2) => (-1))" data-key="activeInvoice.id">
      <DataTable :value="processInvoiceList(activeInvoice.invoiceDatas)" :autoLayout="true" data-key="order.id" :key="activeInvoice.id" :selection.sync="selectedOrdersToRemove[activeInvoice.id]">
        <template #header>
          <div class="p-d-flex">
            <div class="p-inputgroup">
              <Button label="Lägg till" icon="pi pi-plus" :disabled="selectedFinishedOrders.length == 0" @click="appendToInvoice(activeInvoice.id, selectedFinishedOrders)" />
              <Button label="Ta bort" icon="pi pi-minus" class="p-button-danger" :disabled="selectedOrdersToRemove[activeInvoice.id] === undefined || selectedOrdersToRemove[activeInvoice.id].length == 0" @click="removeFromInvoice(activeInvoice.id, selectedOrdersToRemove[activeInvoice.id])" />
              <span class="p-inputgroup-addon" style="color: black">
                {{activeInvoice.name}}
              </span>
            </div>
          </div>
        </template>
        <Column selectionMode="multiple" headerStyle="width: 3em" />
        <Column field="date" header="Lossningsdatum" :sortable="true" />
        <Column field="order.Order.data.fraktsedelNr" header="Fraktsedel Nr" :sortable="true" />
        <Column field="order.Order.data.inkopsNr" header="Inköps Nr" :sortable="true" />
        <Column field="order.Order.data.loadingPlaces" header="Lastplats" :sortable="true" />
        <Column field="order.Order.data.deliveryPlaces" header="Lossningsplats" :sortable="true" />
        <Column field="order.Order.data.productId" header="Produkt" :sortable="true" />
        <Column field="order.Order.data.retur" header="Retur" :sortable="true">
          <template #body="slotProps">
            <i :class="slotProps.data.order.Order.data.retur ? 'pi pi-check' : 'pi pi-times'"></i>
          </template>
        </Column>
        <Column header="Lastat">
          <template #body="slotProps">
            {{fimCalculateLoadedAmount(slotProps.data.order.Order.data) | round2dec}}
          </template>
        </Column>
        <template #footer>
          <div class="p-d-flex p-jc-between">
            <div>
              <Button label="Fakturera" icon="pi pi-check" class="p-button-success" :disabled="activeInvoice.invoiceDatas.length === 0" @click="$router.push({ name: 'InvoiceFeralcoInternCreate', params: { id: activeInvoice.id } })" />
            </div>
            <div>
              <Button label="Ta Bort Faktura" icon="pi pi-minus" class="p-button-danger" :disabled="activeInvoice.invoiceDatas.length > 0" @click="deleteInvoice(activeInvoice.id)" />
              <Button label="Arkivera" icon="pi pi-minus" class="p-button-danger" @click="archiveInvoice(activeInvoice.id)" />
            </div>
          </div>
        </template>
        <template #empty>
          Inga ordrar tillagda på {{activeInvoice.name}}
        </template>
      </DataTable>
    </template>

  </div>
</template>
<script>

import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import SplitButton from 'primevue/splitbutton'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Dialog from 'primevue/dialog'
import moment from 'moment'

import { mapGetters } from 'vuex'

import { FeralcoInternMixin } from '@/mixins/FeralcoInternMixin'

export default {
  name: 'InvoiceFeralcoInternList',
  mixins: [FeralcoInternMixin],
  components: {
    DataTable,
    Column,
    SplitButton,
    Button,
    InputText,
    Dialog
  },
  data () {
    return {
      editAllowed: false,
      newInvoice: false,
      newInvoiceName: '',
      createInvoice: -1,
      filters: {},
      selectedOrdersToRemove: {},
      selectedFinishedOrders: [],
      items: [
        {
          label: 'Ladda nya',
          icon: 'pi pi-refresh',
          command: () => {
            this.$store.dispatch('GET_FINISHED_ORDERS')
          }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('GET_FINISHED_ORDERS')
    this.$store.dispatch('GET_ACTIVE_INVOICES')
    this.$store.dispatch('GET_VISMA_ARTICLES')
  },
  computed: {
    ...mapGetters(['FINISHED_ORDERS', 'FINISHED_ORDERS_BY_TYPE', 'INVOICES', 'INVOICES_BY_TYPE', 'INVOICES_NEW_BY_TYPE'])
  },
  methods: {
    processOrderList (orders) {
      return orders.map((order) => {
        return { date: this.getDeliveryDate(order.data.dateDelivery), order: order }
      })
    },
    deProcessOrderList (orders) {
      return orders.map((order) => {
        return {...order.order}
      })
    },
    processInvoiceList (orders) {
      return orders.map((order) => {
        return { date: this.getDeliveryDate(order.Order.data.dateDelivery), order: order }
      })
    },
    async refresh () {
      await this.$store.dispatch('GET_FINISHED_ORDERS')
      await this.$store.dispatch('GET_ACTIVE_INVOICES')
    },
    async refreshAndClear () {
      await this.refresh()
      this.selectedFinishedOrders = []
    },
    async addToNewInvoice (name, orders) {
      await this.$store.dispatch('ADD_ORDERS_TO_NEW_INVOICE', { invoiceType: 'feralcoIntern', invoiceName: name, orders: this.deProcessOrderList(orders) })
      await this.refreshAndClear()
      this.newInvoice = false
      this.newInvoiceName = ''
    },
    async appendToInvoice (invoiceId, orders) {
      await this.$store.dispatch('ADD_ORDERS_TO_INVOICE', { invoice: invoiceId, orders: this.deProcessOrderList(orders) })
      await this.refreshAndClear()
    },
    async removeFromInvoice (invoiceId, orders) {
      await this.$store.dispatch('REMOVE_ORDERS_FROM_INVOICE', { invoice: invoiceId, orders: this.deProcessOrderList(orders) })
      await this.refresh()
      this.selectedOrdersToRemove[invoiceId] = []
    },
    archiveInvoice (invoiceId) {
      let message = 'Är du säker?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          this.$store.dispatch('ARCHIVE_INVOICE', invoiceId)
          this.refresh()
        })
        .catch(function (e) {
          console.log('Clicked on cancel')
        })
    },
    async deleteInvoice (invoiceId) {
      await this.$store.dispatch('DELETE_INVOICE', invoiceId)
      await this.refresh()
    },
    async archiveOrder (orderId) {
      await this.$store.dispatch('CHANGE_ORDER_STATE', { id: orderId, state: 'arkiverad' })
    },
    async resetOrder (orderId) {
      await this.$store.dispatch('CHANGE_ORDER_STATE', { id: orderId, state: 'avslutad' })
    },
    getDeliveryDate (date) {
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Invoices/InvoiceFeralcoInternList.vue